import React from "react";
import ServiceDetailPage from "./ServiceDetailPage";

export default function ITInfrastructure() {
  return (
    <ServiceDetailPage
      pageClassName="itinfra"
      heroClassName="itinfra-hero"
      title="IT Infrastructure"
      subtitle="Servers, storage, virtualization, resilient power, and secure access—engineered for performance and efficiency."
      heroPrimaryLabel="Explore Overview"
      heroSecondaryLabel="Book a Technical Consult"
      overviewLead="From server rooms to hybrid clouds, we deliver robust infrastructure with automation, observability, and built‑in resilience."
      overviewBullets={[
        "Virtualization and container platforms",
        "High‑availability storage and backups",
        "Power, UPS, and solar‑assisted solutions",
        "Identity & access with least‑privilege",
        "Configuration management and IaC",
      ]}
      features={[
        { title: "Servers & Virtualization", description: "VM clusters, Kubernetes, and automation‑ready builds." },
        { title: "Storage & Backup", description: "Tiered storage, snapshots, and immutable backups." },
        { title: "Power & Resilience", description: "UPS sizing, generators, and solar‑assisted designs." },
        { title: "Identity & Access", description: "SSO, MFA, and role‑based access controls." },
        { title: "Endpoint Management", description: "Device enrollment, patching, and compliance baselines." },
        { title: "Cloud & Hybrid", description: "Secure landing zones and cost‑optimized workloads." },
      ]}
      solutionsHeading="Solution Patterns"
      solutions={[
        {
          title: "On‑Prem Foundations",
          description: "Racks, power, cooling, and secure network cores.",
          items: ["HA compute and storage", "Out‑of‑band management", "Policy‑based segmentation"],
        },
        {
          title: "Hybrid Cloud",
          description: "Extend on‑prem to cloud with safe network patterns.",
          items: ["Landing zones & guardrails", "Observability and cost control", "DR to cloud"],
        },
        {
          title: "End‑User Compute",
          description: "Secure devices with automated provisioning and SSO.",
          items: ["MDM/EMM with zero‑touch", "Patch orchestration", "Compliance reporting"],
        },
        {
          title: "Resilience & DR",
          description: "Business continuity for critical workloads.",
          items: ["RTO/RPO aligned designs", "Failover runbooks", "Regular drills & audits"],
        },
      ]}
      pricingLead="Engagements are tailored to your estate size and SLAs."
      pricingTiers={[
        {
          title: "Assessment",
          description: "Baseline review with actionable roadmap.",
          items: ["Infra health checks", "Security posture", "Cost & performance"],
        },
        {
          title: "Implementation",
          description: "Hands‑on build, migrate, and optimize.",
          items: ["Automation & IaC", "Resilience & DR", "Security & compliance"],
          featured: true,
        },
        {
          title: "Managed",
          description: "Ongoing ops with SLAs and reporting.",
          items: ["24/7 monitoring", "Patch & backup mgmt", "Monthly reviews"],
        },
      ]}
      contactTitle="Talk to an Infrastructure Architect"
      contactLead="We’ll help you design a reliable, efficient foundation."
    />
  );
}